import {connect} from 'react-redux';
import List from './List';
import {fetchTimeSensitiveItemTypes} from 'src/redux/admin/actions/timeSensitiveItemTypes';

export default connect(null, {fetchTimeSensitiveItemTypes})(List);
